import SearchIcon from '@mui/icons-material/Search'
import { Box, Button, TextField, Typography } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface IGetInvoiceParams {
  keyword?: string
  userId?: number
  limit?: number
  offset?: number
}

interface IHeaderInvoiceProps {
  onSubmit: (values: {
    keyword?: string
    userId?: number
  }) => void
  options: {
    id: number
    name: string
  }[]
  onFocus: () => void
  searchId: number
  handleSearchId: (id: number) => void
}

export const HeaderProformaInvoice: React.FC<IHeaderInvoiceProps> = ({
  onSubmit,
  options,
  onFocus,
  searchId = 0,
  handleSearchId
}): JSX.Element => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  // @ts-ignore
  const [userId, setUserId] = useState<number>(location.state?.userId || 0)
  // @ts-ignore
  const [keyword, setKeyword] = useState<string>(location.state?.keyword || '')

  useEffect(() => {
    if (searchId) {
      setUserId(searchId)
      onSubmit({userId: searchId})
      handleSearchId(0)
    }
  }, [searchId, onSubmit, handleSearchId])

  const handleChange = (event: SelectChangeEvent): void => {
    setUserId(Number(event.target.value))
  }

  const handleKeyword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKeyword(event.target.value)
  }

  const onSubmitSearch = () => {
    const values = {
      keyword: keyword,
      userId: userId
    }
    onSubmit(values)
    return false
  }

  return (
    <>
      <Box display={'flex'} sx={{ mb: '24px', mt: '4px' }}>
        <TextField
          value={keyword}
          onChange={handleKeyword}
          size={'small'}
          sx={{ minWidth: 220, background: 'white' }}
          label={t('list_proforma_invoice.keyword')}
          id="outlined-basic"
          variant="outlined"
          InputLabelProps={{
            style: {
              fontSize: 16,
              paddingLeft: 4,
              paddingRight: 4,
              color: 'rgba(0, 0, 0, 0.6)',
            },
          }}
          inputProps={{
            style: {
              fontSize: 16,
              height: 40,
              minWidth: 192,
              padding: '0 14px',
              fontWeight: 400,
            },
          }}
        />
        <FormControl
          size={'small'}
          sx={{ minWidth: '220px', marginLeft: '8px', background: 'white' }}
        >
          <InputLabel
            id="list-proforma-invoice-select-label"
            sx={{
              fontSize: 16,
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
              letterSpacing: 0.15,
            }}
          >
            {t('list_proforma_invoice.filter')}
          </InputLabel>
          <Select
            labelId="list-proforma-invoice-select-label"
            id="list-proforma-invoice-select"
            value={userId ? String(userId) : ''}
            label="User Id"
            onChange={handleChange}
            onFocus={onFocus}
            MenuProps={{
              style: {
                marginTop: 1,
                maxHeight: '510px',
                maxWidth: '200px',
              },
            }}
            sx={{
              '& .MuiOutlinedInput-input': {
                fontSize: 16,
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 400,
              },
              height: '40px',
            }}
          >
            <MenuItem value=""></MenuItem>
            {options.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant="contained" sx={{ marginLeft: '8px' }} onClick={onSubmitSearch}>
          <SearchIcon fontSize={'small'} />
          <Typography
            sx={{
              marginLeft: '12px',
              fontStyle: 'normal',
              fontSize: 14,
              lineHeight: '24px',
              fontFamily: 'Roboto',
            }}
          >
            {t('list_proforma_invoice.search')}
          </Typography>
        </Button>
      </Box>
    </>
  )
}
